<template>
<div class="devDetailDW basicInfoContainerGas">
  <div class="detailsDrawerBody" :style="styleObject">
    <div class="basic detailsItem">
      <!-- <h4>年检记录</h4> -->
      <div class="details">
        <el-scrollbar wrap-class="scrollbar-wrapper" ref="myScrollbar">
          <ul>
            <li>
              <div class="label">IMEI</div>
              <div class="value">{{ datailsData.imei }}</div>
            </li>
            <li>
              <div class="label">报警状态</div>
              <div class="value">{{ datailsData.isAlarm }}</div>
            </li>
            <li>
              <div class="label">故障状态</div>
              <div class="value">{{ datailsData.isFault }}</div>
            </li>
            <li v-if="datailsData.isInstall  == '已安装'">
              <div class="label">安装时间</div>
              <div class="value">{{ datailsData.installTime }}</div>
            </li>
            <li v-if="datailsData.isInstall  == '已安装'">
              <div class="label">上一次年检时间</div>
              <div class="value">{{ datailsData.installTime }}</div>
            </li>
            <li v-if=" datailsData.isInstall == '已安装' ">
              <div class="label">年检负责人</div>
              <div class="value">{{ datailsData.installUser }}</div>
            </li>
            <li v-if=" datailsData.isInstall == '已安装' ">
              <div class="label">年检负责人联系方式</div>
              <div class="value">{{ datailsData.installUserTel }}</div>
            </li>
            <li v-if="datailsData.isInstall  == '已安装'">
              <div class="label">下一次年检时间</div>
              <div class="value">{{ datailsData.nextInspectionTime }}</div>
            </li>
          </ul>
          <div class="btn-box">
            <el-button type="primary" @click="handleClick(1)" :loading="loading1">复位</el-button>
            <el-button type="primary" @click="handleClick(2)" :loading="loading2">远程关阀</el-button>
            <el-button type="primary" @click="handleSave(1)" :loading="loading1" v-if="type == 'smokeands'">消音</el-button>
            <el-button type="primary" @click="handleClickSet" v-if="type == 'smokeands'">人存下发</el-button>
            <el-button type="primary" @click="handleClickSetM" v-if="type == 'smokeands'">人存在检测间隔</el-button>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
  <!-- 设置布防撤防时间 -->
  <el-dialog title="下发设置" :visible.sync="isShowSet" width="480px">
    <div class="dialog-box">
      <ul class="edit-dialog">
        <li>
          <span class="title">操作</span>
          <div class="switch-box">
            <el-select v-model="setParams.commondRun" placeholder="请选择下发操作">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </li>
        <li class="time" v-show="setParams.commondRun == '0604'">
          <span class="title">布防时间</span>
          <el-select v-model="setParams.beginTime" placeholder="开始时间" @change="handleTimeChange">
            <el-option
              v-for="item in optionsBeginTime"
              
              :key="item"
              :label="`${item}:00`"
              :value="item" />
          </el-select>
          -
          <el-select v-model="setParams.endTime" placeholder="结束时间" @change="handleTimeChange">
            <el-option
              v-for="(item, i) in optionsBeginTime"
              :key="item"
              :label="`${item}:00`"
              :value="item" />
              <!-- :label="`${item}:00${i == 0 ? '(24点)' : ''}`"
              :value="`${i == 0 ? 24 : item}`" /> -->
          </el-select>
        </li>
      </ul>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSave(2)">保 存</el-button>
    </span>
  </el-dialog>
  <el-dialog title="人存在检测间隔" :visible.sync="isShowSetM" width="480px">
    <div class="dialog-box">
      <ul class="edit-dialog">
        <li>
          <span class="title">人体存在检测间隔</span>
          <div class="switch-box">
            <el-input-number v-model="time" :precision="0" :min="1" :max="9999" :step="2" label="间隔时间"></el-input-number> 分钟
          </div>
        </li>
        <li class="tip">单位分钟，默认10分钟，十进制数字</li>
      </ul>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSave(3)">保 存</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import { LOAD_CHILDREN_OPTIONS, Treeselect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
var dayjs = require('dayjs')
import {
  BaiduMap,
  BmNavigation,
  BmView,
  BmGeolocation,
  BmCityList
} from 'vue-baidu-map'
export default {
  components: {
    BaiduMap,
    BmNavigation,
    BmView,
    BmGeolocation,
    BmCityList,
    Treeselect
  },
  props: {
    deviceId: {
      type: Number,
      default: () => {
        return null;
      }
    },
    deviceImei: {
      type: [Number, String],
      default: () => {
        return null;
      }
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: null
    },
    typeId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      options: [
        { label: '全天布妨', value: '0601' },
        { label: '全天撤防', value: '0602' },
        { label: '火警状态时布防', value: '0603' },
        { label: '按时间布防', value: '0604' },
      ],
      optionsBeginTime: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      optionsEndTime: [],
      regionOptions:[{
        id: 0,
        label: '区域机构',
        value: 0,
        isDefaultExpanded: true,
        children: null
      }],
      regionId: null,
      mapShow: false,
      mapSearch: '',
      center: {
        lng: '116.404',
        lat: '39.915'
      },
      location: {
        lng: '116.404',
        lat: '39.915'
      },
      keyword: '',
      zoom: 14,
      baiduMap: null,
      map: null,
      geocoder: null,
      locationSelected: false,
      selectLocation: {},
      // selectAddress:{},
      styleObject: {
        height: ''
      },
      datailsData: {},
      disabled: false,
      mapWidth: 0,
      mapHeight: 0,
      commitFlag: false,
      styleObj: {},
      flag: false,
      regionInfos:[],
      regionName:'',
      isShow: false,
      isUnOut: false,
      loading1: false,
      loading2: false,
      tempTimmer: null,
      isShowSet: false,
      isShowSetM: false,
      setParams: {
        commondRun: '',
        endTime: '',  // 无人结束时间
        beginTime: '',  // 无人开始时间
      },
      time: 10
    };
  },
  watch: {
    deviceId(newV) {
      console.log(newV);
    },
    isMobile(newV) {
      console.log(newV);
    }
  },
  created() {
    console.log(1111111, this.type)
    // this.showRegionOptions()
    this.mapWidth = document.body.clientWidth * 0.8
    this.mapHeight = document.body.clientHeight * 0.8
    // console.log(this.deviceId)
    this.makeheight()
    this.detailDatas()
    // console.log(123, this.typeId)
  },
  mounted() {
    let isMaxTenant = this.storage.getSession("isMaxTenant")
    // console.log(isMaxTenant == 0)
    // console.log(this.isMobile)
    if (isMaxTenant == 0 && this.isMobile) {
      this.isShow = true
    }
  },
  methods: {
    /**
     * @Description 时间更改
     * @Author      YOYO     -             2022-08-08
     */
    handleTimeChange () {
      const { beginTime, endTime } = this.setParams
      if (beginTime == '' || endTime == '') return
      if (endTime < beginTime) {
        this.$message({ type: 'success', message: `布防时间为${beginTime}点 至次日${endTime}点！` })
        // this.$message({ type: 'success', message: `布防结束时间不能早于布防开始时间，请重新选择！` })
        // this.setParams.beginTime = ''
        // this.setParams.endTime = ''
      } else if (endTime == beginTime) {
        this.$message({ type: 'warning', message: '24小时布防时，请直接：【操作】选择【全天布防】！', duration: 5000 })
        this.setParams.beginTime = ''
        this.setParams.endTime = ''
      }
    },
    /**
     * @Description 设置保存
     * @Author      YOYO     -             2021-11-27
     */
    async handleSave (type) {
      const { commondRun, beginTime, endTime } = this.setParams

      let commond = ''

      if (type == 1) {
        commond = '0101'
      } else if (type == 2) {
        if (!commondRun) return this.$message({ type: 'warning', message: '请选择你要下发的操作动作！' })
        if (commondRun == '0604' && (beginTime == '' || endTime == '')) return this.$message({ type: 'warning', message: '请选择布妨时间！' })
        commond = commondRun == '0604' ? `06${beginTime}${endTime}` : commondRun
      } else {
        let { time } = this
        if (!time) return this.$message({ type: 'warning', message: '请填写间隔时间！' })
        const numStr = String(time)
        const paddedNum = numStr.padStart(4, '0')
        commond = '07' + paddedNum
      }
      let { code, data, msg } = await this.request.post(`/front/device/smokeands/${this.deviceId}/${commond}`)
      if (code != 200) return this.$message({ type: 'warning', message: msg })

      this.detailDatas()
      this.isShowSet = false
      this.isShowSetM = false
      this.$message({ type: 'success', message: '下发成功！' })
    },
    handleClickSet () {
      let { humFunction } = this.datailsData
      
      this.setParams.commondRun = humFunction
      if (humFunction?.length > 4) {
        this.setParams = {
          commondRun: '0604',
          beginTime: humFunction.slice(2, 4),  
          endTime: humFunction.slice(4, 6)
         }
      }
      this.isShowSet = true
    },
    handleClickSetM () {
      let { humt } = this.datailsData
      if (humt?.length >= 6) {
        let str = humt.slice(-4)
        // console.log(str)
        this.time = str
      }
      this.isShowSetM = true
    },
    detailDatas() { //详情
      let self = this
      let type = this.type ?? 'gateway'
      this.request.get(`/front/device/${type}/${this.deviceId}`).then((res) => {

        if (res.code === 200) {
          // nextInspectionTime
          if (res.data && res.data.installTime) {
            let temp = dayjs(res.data.installTime).add(1, 'year').format('YYYY-MM-DD hh:mm:ss')
            
            if (temp) {
              res.data.nextInspectionTime = temp
            }

          }
          this.datailsData = res.data
        } else if (res.code === 500) {
          this.msg.warn(res.msg)
        }
      })
    },
    makeheight(height = 260) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    handleClick (type) {
      this.tempTimmer && clearTimeout(this.tempTimmer)
      let thing = type == 1 ? '复位' : '远程关阀'
      this.$alert(`您确定要${thing}？`, '提示', {
        confirmButtonText: '确定',
        callback: action => {
          this[`loading${type}`] = true

          this.tempTimmer = setTimeout(() => {
            this[`loading${type}`] = false
            this.$message({ type: 'info', message: `${ thing }成功`})
          }, type * 1000)
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.basicInfoContainerGas {
  .detailsDrawerBody {
    // padding: 10px 35px;

    .detailsItem {
      height: 100%;
      padding-left: 20px;

      h4 {
        font-size: 16px;
        color: #333;
        line-height: 38px;
        font-weight: bold;
        border-bottom: 1px solid #aaa;
      }

      .details {
        padding: 10px 0;
        height: 100%;

        ul {
          overflow: hidden;

          li {
            float: left;
            width: 33.33%;
            line-height: 38px;
            margin: 0 0 5px 0;

            .label {
              // display: inline-block;
              vertical-align: middle;
              color: #333;
              width: 300px;
            }

            .value {
              // display: inline-block;
              // width: calc(100% - 200px);
              width: 290px;
              height: 38px;
              padding: 0 5px 0 10px;
              box-sizing: border-box;
              vertical-align: middle;
              color: #888;
              // background: rgba(16, 137, 255, 0.05);
              background: #f4f4f5;
              border-radius: 2px;
              overflow: hidden;
              text-overflow: nowrap;
              white-space: ellipsis;

              .unit {
                margin-left: 10px;
              }
            }
          }
        }

        .submitBtns {
          overflow: hidden;

          .delSome {
            width: 82px;
            height: 36px;
            cursor: pointer;
            float: left;
            margin-right: 20px;
            font-size: 14px;
            font-family: AlibabaPuHuiTi-Medium;
            line-height: 36px;
            border: 0;
            color: #FFFFFF;
            background: #1089FF;
            border-radius: 4px;

            &:hover {
              background: #0774e0;
            }
          }

          .uninstall {
            background: #fff;
            border: 1px #1089FF solid;
            color: #1089FF;

            &:hover {
              background: rgba(16, 137, 255, 0.05);
            }
          }
          .uninstalls{
            background: #fff;
            border: 1px #ff9900 solid;
            color: #ff9900;
            &:hover{
              background: rgba(255, 153, 0, 0.05);
            }
          }
        }

        .unitType {
          font-size: 0;
          position: relative;
          .imgPosition {
            position: absolute;
            width: 38px;
            height: 38px;
            right: 0px;
            top: 0px;
            cursor: pointer;

            img {
              margin:11px 0 0 11px;
              width: 16px;
              height: 16px;
              vertical-align: top;
            }
          }
        }
      }
    }
  }
  .dialog-box {
    .edit-dialog {
      margin-bottom: 10px;
      margin-left: 15px;
      li {
        margin-top: 20px;
        .title {
          font-size: 14px;
          color: #333;
          display: inline-block;
          width: 120px;
        }
      }
      .tip {
        color: red;
        margin-top: 20px;
        font-size: 12px;
      }
    }
    .switch-box {
      display: inline-block;
    }
    .time {
      .el-select {
        width: 130px;
      }
    }
  }
}
</style><style lang="scss">
.basicInfoContainerGas {
  font-family: AlibabaPuHuiTi-Regular;
  .vue-treeselect__control{
    border: none;
    outline: none;
    color: #888;
    // background: rgba(16, 137, 255, 0.05);
    background: #f4f4f5;
    .vue-treeselect__single-value{
      color: #888;
    }
    .vue-treeselect__input{
      height: 38px;
      color: #888;
    }
  }
  .detailsDrawerBody .detailsItem .details ul li .treeselect-box {
    overflow: visible!important;
  }
  .deviceName {
    font-size: 0;

    .el-input {
      font-size: 0;
      display: inline-block;
      width: 100%;

      .el-input__inner {
        color: #888;
        height: 38px;
        line-height: 38px;
        font-size: 14px;
        padding: 0;
        border: unset;
        outline: unset;
        background: unset;
      }
    }
  }

  .unitType {
    font-size: 0;

    .el-input {
      font-size: 0;
      display: inline-block;
      width: 90%;

      .el-input__inner {
        color: #888;
        height: 38px;
        line-height: 38px;
        font-size: 14px;
        padding: 0;
        border: unset;
        outline: unset;
        background: unset;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .unitMap {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 10;
    transition: all 0.1s;

    .closeBtn {
      position: absolute;
      top: 30px;
      right: 80px;
      font-size: 50px;
      color: #fff;
      cursor: pointer;
    }

    .mapBox {
      position: absolute;
      width: 80%;
      height: 80%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden;

      .input-box {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 180px;
        height: 60px;
        padding: 5px 10px;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        label {
          display: block;
          color: #666;
        }
        #tipinput {
          margin-top: 10px;
          height: 25px;
          border: 1px solid #ccc;
        }
      }      
      #map {
        width: 100%;
        height: 100%;
      }

      // .mapSearch {
      //   position: absolute;
      //   top: 10px;
      //   left: 10px;
      //   z-index: 1000;
      //   font-size: 0;

      //   .el-input {
      //     width: 300px;
      //     height: 40px;
      //     vertical-align: middle;
      //     margin-right: 10px;
      //     box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);

      //     .el-input__inner {
      //       width: 300px;
      //       height: 40px;
      //     }
      //   }

      //   .el-button {
      //     vertical-align: middle;
      //     height: 40px;
      //     line-height: 40px;
      //     padding: 0 10px;
      //     box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
      //   }
      // }

      .mapConfirm {
        position: absolute;
        bottom: 0px;
        left: 0px;
        right: 0px;
        background: rgba(0, 0, 0, 0.8);
        padding: 10px 20px;
        cursor: pointer;

        span {
          float: left;
          color: #fff;
          font-size: 20px;
          width: 500px;
          line-height: 36px;
        }

        i {
          float: right;
          background: #f77a27;
          font-style: normal;
          height: 36px;
          line-height: 36px;
          border-radius: 18px;
          padding: 0 20px;
          color: #fff;
          font-size: 20px;
        }
      }
    }
  }

  .dialog-box {
    .el-input__inner {
      height: 40px;
      line-height: 40px;
    }
  }
}
</style>
